// Reducer for the details of a topic.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTopicPlanState = {
  ...DefaultState
}

export const topicPlan = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicPlanState,
  actionRequest: ActionTypes.REQUEST_TOPIC_PLAN,
  actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN,
  actionInvalidate: ActionTypes.INVALIDATE_TOPIC_PLAN
})


export const DefaultTopicPlanAnticipationState = {
  ...DefaultState
}

export const topicPlanAnticipation = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicPlanAnticipationState,
  actionRequest: ActionTypes.REQUEST_TOPIC_PLAN_ANTICIPATION,
  actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_ANTICIPATION_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN_ANTICIPATION,
  actionInvalidate: ActionTypes.INVALIDATE_TOPIC_PLAN_ANTICIPATION
})